const DEPARTMENT = {
    DEFAULT: '',
    ALTERNATIVE: 'Alternative',
    TRAVEL_AGENCY: 'Reisebüro Leipzig'
};

export const mapHotlinePhone = {
    [DEPARTMENT.DEFAULT]: "0341 65050 51060",
    [DEPARTMENT.TRAVEL_AGENCY]: "0341 65050 55550",
    [DEPARTMENT.ALTERNATIVE]:  "0341 65050 51050"
  }